export const STUB_PASSWORD = 'stub-password';
